import {
    SiFacebook,
    SiYoutube,
    SiTiktok,
    SiInstagram,
    SiX,
    SiDiscord,
    SiPatreon,
    SiBuymeacoffee,
    SiKofi,
    SiPaypal,
} from "react-icons/si";
import { Globe, Mail, Coffee, Link as LinkIcon } from "lucide-react";

// Accurate brand icons (Simple Icons) + brand colors tuned for the dark theme
export const PLATFORMS = {
    facebook: { label: "Facebook", Icon: SiFacebook, color: "#1877F2", category: "social" },
    youtube: { label: "YouTube", Icon: SiYoutube, color: "#FF0000", category: "social" },
    tiktok: { label: "TikTok", Icon: SiTiktok, color: "#FE2C55", category: "social" },
    instagram: { label: "Instagram", Icon: SiInstagram, color: "#E4405F", category: "social" },
    twitter: { label: "X / Twitter", Icon: SiX, color: "#FFFFFF", category: "social" },
    discord: { label: "Discord", Icon: SiDiscord, color: "#5865F2", category: "social" },
    website: { label: "Strona WWW", Icon: Globe, color: "#60A5FA", category: "social" },
    email: { label: "E-mail", Icon: Mail, color: "#FACC15", category: "kontakt" },
    patreon: { label: "Patreon", Icon: SiPatreon, color: "#FF424D", category: "support" },
    buycoffeeto: { label: "buycoffee.to", Icon: Coffee, color: "#22C55E", category: "support" },
    buymeacoffee: { label: "Buy Me a Coffee", Icon: SiBuymeacoffee, color: "#FFDD00", category: "support" },
    kofi: { label: "Ko-fi", Icon: SiKofi, color: "#FF5E5B", category: "support" },
    paypal: { label: "PayPal", Icon: SiPaypal, color: "#0070BA", category: "support" },
    other: { label: "Inne", Icon: LinkIcon, color: "#94A3B8", category: "social" },
};

export function getPlatformMeta(platform) {
    return PLATFORMS[platform] || PLATFORMS.other;
}

export const PLATFORM_OPTIONS = Object.entries(PLATFORMS).map(([id, meta]) => ({
    id,
    label: meta.label,
    category: meta.category,
}));

export const CATEGORY_LABELS = {
    social: "Social media",
    kontakt: "Kontakt",
    support: "Wsparcie",
};
